<template>
    <window :title="title">
        <Material
            :contents-json="contents"
            :autoplay-option="false"
            :readdir="dir"
        >
            <template #next-contents
                ><router-link
                    class="btn btn-outline-dark"
                    :to="`/test/${contentsName}`"
                    >テスト編へ進む</router-link
                ></template
            >
        </Material>
    </window>
</template>

<script>
import Material from "@/components/material";

export default {
    name: "answer",
    components: {
        Material,
    },
    data() {
        return {
            title: "解説編",
            dir: `answer_${this.$route.params.contents}`,
            contentsName: this.$route.params.contents,
        };
    },
    computed: {
        contents() {
            let res = require(`@/assets/answer.json`);
            let json = res.find((item) => item.dir == this.dir);
            return json;
        },
    },
};
</script>